import { TableCell, TableRow } from "@/shared/components/ui/table";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function TableRtkErrorRow({
  error,
  colSpan,
  showValidationErrors = false,
}: {
  error: unknown;
  colSpan: number;
  showValidationErrors?: boolean;
}) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <RTKQueryErrorAlert
          error={error}
          ignoreValidationError={!showValidationErrors}
        />
      </TableCell>
    </TableRow>
  );
}
